export default "__VITE_ASSET__12665d7a__"